
      import('/src/domains/analytics/services/Tracker.ts').then(m => m.Tracker.track('load')).catch(() => {});
    